import { render } from "./BackButton.vue?vue&type=template&id=d6d5eb84"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=d6d5eb84&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__